"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = _interopRequireDefault(require("../../styles/components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ListItem = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(ListItem, _React$PureComponent);

  function ListItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var _this$props = _this.props,
          value = _this$props.value,
          onClick = _this$props.onClick;
      onClick(value);
    });

    return _this;
  }

  var _proto = ListItem.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        icon = _this$props2.icon,
        title = _this$props2.title,
        badge = _this$props2.badge,
        extra = _this$props2.extra,
        value = _this$props2.value,
        selected = _this$props2.selected;
    return /*#__PURE__*/_react["default"].createElement(_components["default"].ListItem, null, false && /*#__PURE__*/_react["default"].createElement(_components["default"].ListItemExtra, null, /*#__PURE__*/_react["default"].createElement(_components["default"].ListCheckbox, {
      key: selected,
      checked: selected,
      onClick: this.handleClick
    })), /*#__PURE__*/_react["default"].createElement(_components["default"].ListItemContent, null, /*#__PURE__*/_react["default"].createElement(_components["default"].ListItemTitle, null, icon, " ", title), badge !== undefined && /*#__PURE__*/_react["default"].createElement(_components["default"].ListItemBadge, null, badge)));
  };

  return ListItem;
}(_react["default"].PureComponent);

var _default = ListItem;
exports["default"] = _default;